import Workshop from './Workshop';

export default Workshop;
